import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Category = {
  id: string;
  name: string;
  slug: string;
  created_at: string;
};

export type Product = {
  id: string;
  name: string;
  image_url: string | null;
  tag: string | null;
  category_id: string | null;
  section: string;
  whatsapp_message: string | null;
  display_order: number;
  created_at: string;
};

export type Video = {
  id: string;
  title: string;
  label: string | null;
  caption: string | null;
  src: string | null;
  display_order: number;
  created_at: string;
};

export type SiteSetting = {
  key: string;
  value: string | null;
  updated_at: string;
};
